import get from 'lodash/get';

import types from './types';

import {promiseAction} from '~/misc/dispatch';
import create, {prepare} from '~/misc/create';
import {geocomplete} from '~/misc/geocoding';
import {loadPlace} from '~/modules/places/actions';
import {openDropdown, closeDropdown} from '~/modules/dropdowns/actions';
import { type } from 'os';

const requestData = (criteria, country) => {
  if (!criteria) {
    return Promise.resolve(null);
  }

  return geocomplete(criteria, country);
};

export const checkDropDown = (dispatch, state, id) => {

  const hasFocus = get(state, ['geosearch', id, 'hasFocus']);
  if (!hasFocus) {
    dispatch(closeDropdown(id));
    return;
  }

  const hasUSResults = get(state, ['geosearch', id, 'search', 'us', 'list', '0']);
  const hasCAResults = get(state, ['geosearch', id, 'search', 'ca', 'list', '0']);

  if (!hasUSResults && !hasCAResults) {
    dispatch(closeDropdown(id));
    return;
  }

  dispatch(openDropdown(id));
};

export const updateCriteria = prepare(types.GEOSEARCH_CRITERIA, (id, criteria) => ({id, criteria}));
export const updateFromStateName = prepare(types.GEOSEARCH_SAVE_VALUE, (id, state) => ({id, state}));

export const geosearch = (id, criteria, skipDropdown) => (dispatch, getState) => {
  const stateCriteria = get(getState(), ['geosearch', id, 'criteria']);
  if (criteria !== stateCriteria) {
    return Promise.resolve();
  }

  if (!criteria) {
    if (!skipDropdown) {
      dispatch(closeDropdown(id));
    }
    return Promise.resolve();
  }
  return Promise.all([
    promiseAction(dispatch, getState, types.GEOSEARCH_RESULTS, requestData(criteria, 'us'), {id, country: 'us'}),
    // promiseAction(dispatch, getState, types.GEOSEARCH_RESULTS, requestData(criteria, 'ca'), {id, country: 'ca'}),
  ]).then(() => {
    if (skipDropdown) {
      return;
    }

    checkDropDown(dispatch, getState(), id);
  });
};

export const selectPlace = (id, country, num, cb) => (dispatch, getState) => {
  const state = getState().geosearch[id].search[country];
  const target = state.list[num];

  dispatch(create(types.GEOSEARCH_SELECTED_PLACE, {id, place: target}));
  return promiseAction(
    dispatch, getState,
    types.GEOSEARCH_READY_PLACE,
    dispatch(loadPlace(target)),
    {id, place_id: target.place_id}
  ).then(() => {
    if(cb){
      cb();
    }
  });
};

export const geoAndGetdetail = (id, criteria, country) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.GEOSEARCH_RESULTS,
  requestData(criteria, country),
  {
    id,
    country: country
  }).then((data) => {
    dispatch(selectPlace(id, country, "0"))
  });

export const checkAndShow = (id, isFocused) => (dispatch, getState) => {
  if (!isFocused) {
    dispatch(create(types.GEOSEARCH_BLUR, {id}));
    dispatch(closeDropdown(id));
    return;
  }

  dispatch(create(types.GEOSEARCH_FOCUS, {id}));
  checkDropDown(dispatch, getState(), id);
};

// MultipleSelect
export const delectSelectOption = (id, key) => (dispatch) => {
  dispatch(create(types.DELECT_GEOSEARCH_OPTION, {id, key}));
}

export const changSelected = (id, selected) => (dispatch) => {
  dispatch(create(types.CHANGE_GEOSEARCH_SELECTED, {id, selected}));
}


export const createOption = (id) => (dispatch) => {
  dispatch(create(types.CREATE_OPTION, {id}));
}

export const multiple_search = (id, criteria) => (dispatch, getState) => {
  const stateCriteria = get(getState(), ['geosearch', id, 'criteria']);
  if (criteria !== stateCriteria) {
    return Promise.resolve();
  }
  return Promise.all([
    promiseAction(dispatch, getState, types.MULTIPLE_GEOSEARCH_RESULTS, requestData(criteria, 'us'), {id, country: 'us'}),
    // promiseAction(dispatch, getState, types.MULTIPLE_GEOSEARCH_RESULTS, requestData(criteria, 'ca'), {id, country: 'ca'}),
  ])
}

export const multiple_set_isShow = (id, key, bol) => (dispatch) => {
  dispatch(create(types.MULTIPLE_SET_ISSHOW, {id, key, bol}));
}

export const multiple_set_key = (id, key) => (dispatch) => {
  dispatch(create(types.MULTIPLE_SET_KEY, {id, key}));
  dispatch(multiple_set_isShow(id, key, true));
  dispatch(create(types.MULTIPLE_SET_TEMPORARY_DATA, {id, key}));
}

export const multiple_selectPlace = (id, country, num) => (dispatch, getState) => {
  const state = getState().geosearch[id].search[country];
  const target = state.list[num];

  dispatch(loadPlace(target)).then(() => {
    dispatch(create(types.MULTIPLE_SELECTED, {
      id,
      place_id: target.place_id,
      selectedResult: target,
    }));
  })
};

export const multiple_updateCriteria = prepare(types.MULTIPLE_GEOSEARCH_CRITERIA, (id, criteria) => ({id, criteria}));

export const checkSelectInput = (id, key) => (dispatch, getState) => {
  const state = getState().geosearch[id];
  if (!state.selected[key].hasOwnProperty('selectedResult')) {
    dispatch(create(types.MULTIPLE_CHECK_SELECT_INPUT, {id, key}));
  }
}

// init
export const multiple_init_select = (id, data) => (dispatch, getState) => {
  dispatch(create(types.MULTIPLE_INIT_SELECT, {id, data}));
}

// claer
export const multiple_clear = () => (dispatch) => {
  dispatch(create(types.MULTIPLE_CLEAR));
}
export const deleteGeosearchList = (id) => (dispatch) => dispatch(create(types.GEOSEARCH_DELETE_LIST, {id}));



// WEBPACK FOOTER //
// ./src/modules/geosearch/actions.js